import { onTimeFlagFromDeliveryStatusLabel } from './fabricationJobCalculations';

/**
 * Excel column headers for fabrication jobs (Data sheet).
 * Normalized keys map Excel headers with optional line breaks/spaces.
 */
export const FABRICATION_EXCEL_HEADERS = [
  'Project No',
  'Client',
  'Sector',
  'Promised Month',
  'Quoted Hours',
  'Actual Hours',
  'On-Time Flag',
  'Site',
  'Promised Delivery Date',
  'Actual Delivery Date',
  'Total Welded Joints',
  'Total Joints Rejected',
];

/** Headers that are calculated in UI — ignored on import */
export const FABRICATION_DERIVED_EXCEL_HEADERS = [
  'Hours Variance',
  'Hrs Variance %',
  'Delivery Days Variance',
  'Reject Rate %',
];

export const normalizeExcelHeader = (h) =>
  String(h ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const HEADER_TO_FIELD = {
  'project no': 'projectNo',
  client: 'client',
  sector: 'sector',
  'promised month': 'promisedMonth',
  'quoted hours': 'quotedHours',
  'actual hours': 'actualHours',
  'hours variance': null,
  'hrs variance %': null,
  'hrs variance%': null,
  'delivery status': '__deliveryStatusExcel',
  'on-time flag': 'onTimeFlag',
  'on time flag': 'onTimeFlag',
  site: 'site',
  'promised delivery date': 'promisedDeliveryDate',
  'actual delivery date': 'actualDeliveryDate',
  'delivery days variance': null,
  'total welded joints': 'totalWeldedJoints',
  'total joints rejected': 'totalJointsRejected',
  'reject rate %': null,
  'reject rate%': null,
};

export const mapExcelRowToJobPayload = (rowCells, headerKeys) => {
  const payload = {};
  headerKeys.forEach((header, idx) => {
    const field = HEADER_TO_FIELD[normalizeExcelHeader(header)];
    if (!field) return;
    let val = rowCells[idx];
    if (val == null || val === '') return;
    if (field === 'quotedHours' || field === 'actualHours' || field === 'totalWeldedJoints' || field === 'totalJointsRejected') {
      const n = Number(val);
      if (Number.isFinite(n)) payload[field] = n;
      return;
    }
    if (field === 'promisedDeliveryDate' || field === 'actualDeliveryDate') {
      if (val instanceof Date) {
        payload[field] = val.toISOString();
      } else {
        payload[field] = val;
      }
      return;
    }
    if (field === '__deliveryStatusExcel') {
      const flag = onTimeFlagFromDeliveryStatusLabel(val);
      if (flag != null) payload.onTimeFlag = flag;
      return;
    }
    if (field === 'onTimeFlag') {
      const n = Number(val);
      if (n === 0 || n === 1) payload.onTimeFlag = n;
      return;
    }
    payload[field] = String(val).trim();
  });
  return payload;
};

export const buildHeaderIndexMap = (headerRow) => {
  const keys = headerRow.map((h) => normalizeExcelHeader(h));
  return keys;
};

/** Dropdown on template rows 2–500: onTimeFlag 1 = on time, 0 = late. */
export const applyFabricationTemplateValidations = (sheet) => {
  const colIndex = FABRICATION_EXCEL_HEADERS.indexOf('On-Time Flag') + 1;
  if (colIndex < 1) return;
  const formula = '"1,0"';
  for (let row = 2; row <= 500; row += 1) {
    sheet.getCell(row, colIndex).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [formula],
      showErrorMessage: true,
      errorTitle: 'Invalid value',
      error: 'Use 1 (on time) or 0 (late)',
    };
  }
};
